export default __webpack_public_path__ + "static/media/photo-04.f3e0fd67.jpeg";